import { getIsAdmin } from "../api/providers";

export const checkIsAdmin = async (token: any): Promise<boolean> => {
    try {
        const result = await getIsAdmin(token);
        if (!result.ok) {
            // Maneja el error como consideres necesario
            return false;
        }
        // Devuelve el valor de isAdmin
        return result.isAdmin;

    } catch (error: any) {
        console.log(error.response.data);
        // En caso de error, devuelve false o maneja el error como consideres necesario
        return false;
    }
};